  import { useForm, Controller } from 'react-hook-form';
  import { useSelector, useDispatch } from 'react-redux';
  import {
    createNewSite,
    updateSite,
  //  editSiteSn,
    clearSubmitSiteError,
    selectSitesState,
    modifySite,
    selectSiteById,
  } from '../../redux/slices/sitesSlice';
  import { format } from 'date-fns';
  import { ContactPayload, EquipementState, SitePayload, SiteState } from '../../redux/types';
  import { getPiscineInfos, piscineFields, getSDetailRegister, getClimInfos, getVentilInfos, getEcsInfos, getChauffInfos, chauffFields, ecsFields, climFields, getPlaquesInfos, getFourInfos, plaquesFields, fourFields, ventilFields } from '../../types/siteDetailsInfos';
  import ErrorBox from '../../components/ErrorBox';
  import * as yup from 'yup';
  import { yupResolver } from '@hookform/resolvers/yup';
  import IconDashboard from '@material-ui/icons/Dashboard';
  import InfoIcon from '@material-ui/icons/Info';

  import {
    TextField,
    RadioGroup,
    Radio,
    FormControlLabel,
    Button,
    InputAdornment,
    FormLabel,
    FormControl,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    InputLabel,
    MenuItem,
    Select,
    OutlinedInput,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Tooltip,
    Dialog,
  } from '@material-ui/core';
  import { useFormStyles, useTableStyles } from '../../styles/muiStyles';
  import DateIcon from '@material-ui/icons/DateRangeTwoTone';
  import SubjectIcon from '@material-ui/icons/Subject';
  import React, { ChangeEvent, useEffect, useState } from 'react';
  import { MultiSelectTreeViewProps } from '@material-ui/lab';
  import { SelectProps } from '@material-ui/core';
  import AppMenu from '../../components/AppMenu';
  import { MultiSelect } from "react-multi-select-component";
  import { createContact, updateContact } from '../../redux/slices/contactsSlice';
  import { autoLogin } from '../../redux/slices/authSlice';
  import { fetchConcentrateursForSiteSn } from '../../redux/slices/concentrateursSlice';
  import { fetchEquipementsBySitesSn, fetchEquipementsForSiteSn, selectEquipementsState } from '../../redux/slices/equipementsSlice';
  import { arrayIncludes } from '@material-ui/pickers/_helpers/utils';
  import { Console } from 'console';
  import { RootState } from '../../redux/store';
  /*import { Dropdown } from 'react-nested-dropdown';
  import { ChauffageSelector } from '../../components/ChauffageSelector';*/

  const validationSchema = yup.object({
    site_sn: yup
      .string()
      .required('Required')
      .min(3, 'Must be at least 3 characters')
      .max(60, 'Must be at most 60 characters'),

    cpt_type: yup.string().required('Required'),
  });

  export type occupationProps = {
    siteId: string;
    range: string;
    nombre: number;
    taux: number;
  }
  type statsOccup = {
    [key:string]: occupationProps[];
  }

  interface SiteDetailFormxProps {
    closeDialog?: () => void;
    siteId: string;
    isEditMode: boolean;
    isMobile: boolean;
    equipements: EquipementState[];
    currentData?: SiteState;
  }

  const SiteDetailFormx: React.FC<SiteDetailFormxProps> = ({
    closeDialog,
    isEditMode,
    isMobile,
    siteId,
    equipements,
    currentData,
  }) => {
    const classes = useFormStyles();
    const classes2 = useTableStyles();
    const dispatch = useDispatch();
    const { submitError, submitLoading } = useSelector(selectSitesState);
      //TODO: ne plus passer currentData as SiteState to this part, just send selected siteId, and make a select siteStateById to get 
    // the new parameters saved on form validation
    
    const siteInState = useSelector((state: RootState) =>
      selectSiteById(state, siteId/*, contactId*/)
    );
    currentData = siteInState

    console.log("SiteID: "+siteId)
    let contact = currentData?.contacts?.find((c) => c.site_sn[0] === Number(currentData?.sn_site)) 
      || { id: "", nom: "", prenom: "" , mail: "", tel: "", adresse: "", code_postal: "", actif: true, revenus: "", remarques: "", site_id: [], site_sn: [] };
    
    equipements.map((s) => console.log("USAGE: "+s.usage))

    const chauffDetail: string[][] = []
    currentData?.chauff_detail?.map((detail,index) => {
      let sub = detail.split("+")
      chauffDetail[index] = []
      sub.map((s) => chauffDetail[index].push(s))
      console.log("chauff_detail: "+chauffDetail[index])
    })
    const ecsDetail: string[][] = []
    currentData?.ecs_detail?.map((detail,index) => {
      let sub = detail.split("+")
      ecsDetail[index] = []
      sub.map((s) => ecsDetail[index].push(s))
      console.log("ecs_detail: "+ecsDetail[index])
    })
    const ventilDetail: string[][] = []
    currentData?.ventil_detail?.map((detail,index) => {
      let sub = detail.split("+")
      ventilDetail[index] = []
      sub.map((s) => ventilDetail[index].push(s))
      console.log("ventil_detail: "+ventilDetail[index])
    })
    const climDetail: string[][] = []
    currentData?.clim_detail?.map((detail,index) => {
      let sub = detail.split("+")
      climDetail[index] = []
      sub.map((s) => climDetail[index].push(s))
      console.log("clim_detail: "+climDetail[index])
    })
    //  console.log("currentData.piscine_infos: "+currentData?.piscine_infos)
    console.log("CurrentDate chauffage details: "+currentData?.chauff_detail)
    console.log("CurrentDatas: "+currentData?.ecs_nrj?.map((t)=>t+"-")+" / "+currentData?.ecs_detail?.map((t)=>t+"-")+" / "+currentData?.ecs_rq?.map((t)=>t+"-")+" / "
      +currentData?.chauff_nrj?.map((t)=>t+"-")+" / "+chauffDetail?.map((t)=>t.map((y)=>y+"-"))+" / "+currentData?.chauff_rq?.map((t)=>t+"-"))
    const infosPiscine = getPiscineInfos(currentData?.piscine_infos || [""])
    const infosClim = getClimInfos(currentData?.clim_type || [""], currentData?.clim_detail || [""], currentData?.clim_rq || [""])
    const infosVentil = getVentilInfos(currentData?.ventil_type || [""], currentData?.ventil_detail || [""], currentData?.ventil_rq || [""])
    const infosEcs = getEcsInfos(currentData?.ecs_nrj || [""], currentData?.ecs_detail || [""], currentData?.ecs_rq || [""])
    const infosChauff = getChauffInfos(currentData?.chauff_nrj || [""], chauffDetail/*currentData?.chauff_detail*/, currentData?.chauff_rq || [""])
    const infosPlaques = getPlaquesInfos(currentData?.cuissonplq_nrj || [""], currentData?.cuissonplq_detail || [""], currentData?.cuissonplq_rq || [""])
    const infosFour = getFourInfos(currentData?.four_type || [""], currentData?.four_detail || [""], currentData?.four_rq || [""])
    //  const infosChauff = getChauffInfos(chauffFields.map((cf) => cf.nrj), chauffFields.map((cf) => cf.detail), chauffFields.map((cf) => cf.rq))
    //contact?.revenus !== "Primaire" && contact?.revenus !== "Secondaire" ? contact.revenus = "-" : null
    const [selectedScenario, setSelectedScenario] = useState<String>("");//("update");
    const radioHandlerScenar = (event: React.ChangeEvent<HTMLInputElement>) => {
      console.log("Changement de scénario ! ####################### new scenar: "+(event.target as HTMLInputElement).value)
      setSelectedScenario((event.target as HTMLInputElement).value);
    };
    infosChauff.map((h,index) =>
      console.log("infos chauff details: ["+index+"] = "+h.detail)
    )
    const [openDialog, setOpen] = useState(true);
    const handleClickOpenDialog = () => {
      setOpen(true);
    };

    const handleCloseDialog = () => {
      setOpen(false);
    };    
    function ContactForm() {
      const { register,/* control,*/ handleSubmit, errors } = useForm({
        mode: 'onChange', // onSubmit
        defaultValues:
        {
  //        scenario: "update",
          sn_site: currentData?.sn_site || '',
          site_id: currentData?.id || '',
          ctct_prenom: currentData?.contacts[0]?.prenom || '',//contact?.prenom || '',
          ctct_nom: currentData?.contacts[0]?.nom || '', //contact?.nom || '',
          ctct_tel: currentData?.contacts[0]?.tel || '',
          ctct_mail: currentData?.contacts[0]?.mail || '',
          ctct_adresse: currentData?.contacts[0]?.adresse || '',
          ctct_code_postal: currentData?.contacts[0]?.code_postal || '',
          ctct_actif: currentData?.contacts[0]?.actif || '',
  //        ctct_revenus: contact?.revenus || '',
          ctct_remarques: currentData?.contacts[0]?.remarques || '',
          },
        });
      const [state, setState] = useState({
        selectedRevenus: currentData?.contacts[0].revenus /*.revenus*/ !== undefined 
          && currentData?.contacts[0]?.revenus.length /*contact.revenus.length*/ > 4 ? /*contact*/currentData?.contacts[0].revenus : "Revenus inconnus",
      });
      const selectChange = (event: React.ChangeEvent<{ name?: string | undefined; value: unknown; }>) => {
        console.log("################ e.taget.value: "+event.target.value)
        setState({ ...state, [event.target.name as string]: event.target.value })
      }
      const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
        console.log("Submit CONTACT");
        console.log(data)
        const theContact: ContactPayload = {
          contactId: String(currentData?.contacts[0].id), //String(contact.id),
          nom: data.ctct_nom,
          site_sn: currentData?.contacts[0].site_sn || [], //contact.site_sn,
          site_id: currentData?.contacts[0].site_id || [], //contact.site_id,
          prenom: data.ctct_prenom,
          tel: data.ctct_tel,
          mail: data.ctct_mail,
          adresse: data.ctct_adresse,
          code_postal: data.ctct_code_postal,
          actif: true,
          revenus: state.selectedRevenus ||'',
          remarques: data.ctct_remarques,
        }
  //      console.log("REVENUS: "+state.selectedRevenus)
        isEditMode ? dispatch(updateContact(siteId, theContact/*, closeDialog*/)) : dispatch(createContact(siteId, theContact/*, closeDialog*/))
      });

      return (
        <><><div className={classes2.TopDivider}>
          <form onSubmit={onSubmit/*handleSubmit(onSubmit/*handleUpdateContact*//*isEditMode ? handleUpdateContact : handleCreateContact)*/}>
          <Typography
            variant={isMobile ? 'h5' : 'h4'}
            color="secondary"
            style={{ marginRight: '0.2em', marginTop: '1.5rem' }}
          >Contact <SubjectIcon className={classes2.customIcon} />
          </Typography>
          <Table className={classes2.contactDetailsTable}>
          <TableBody>
            <TableRow>
              <TableCell colSpan={1}>
                <TextField margin='dense'
                  //className={MoreClasses.tiersWidth}
                  inputRef={register}
                  name="ctct_prenom"
                  id="ctct_prenom"
                  type="text"
                  label="Prénom"
                  variant="outlined"
                  fullWidth
                  style={{ marginTop: '1.1em' }} /></TableCell>
              <TableCell colSpan={1}>
                <TextField margin='dense'
                  //className={MoreClasses.tiersWidth}
                  inputRef={register}
                  name="ctct_nom"
                  id="ctct_nom"
                  type="text"
                  label="Nom"
                  variant="outlined"
                  fullWidth
                  style={{ marginTop: '1.1em' }} /></TableCell>
              <TableCell colSpan={1}>
                <TextField margin='dense'
                  //className={MoreClasses.tiersWidth}
                  inputRef={register}
                  name="ctct_tel"
                  id="ctct_tel"
                  type="text"
                  label="Téléphone"
                  variant="outlined"
                  fullWidth
                  style={{ marginTop: '1.1em' }} /></TableCell>
              <TableCell colSpan={1}>
                <TextField margin='dense'
                  //className={MoreClasses.tiersWidth}
                  inputRef={register}
                  name="ctct_mail"
                  id="ctct_mail"
                  type="text"
                  label="@mail"
                  fullWidth
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                  style={{ marginTop: '1.1em' }} /></TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="ctct_adresse"
                  id="ctct_adresse"
                  fullWidth
                  type="text"
                  label="Adresse"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }} /></TableCell>
              <TableCell colSpan={1}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  id="ctct_code_postal"
                  name="ctct_code_postal"
                  type="text"
                  label="Code postal"
                  fullWidth
                  variant="outlined"
                  style={{ marginTop: '1.1em' }} /></TableCell>
              <TableCell colSpan={1}>
              <Select style={{top: '0.33rem', width: '14.15rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                      margin="dense" variant="outlined" onChange={selectChange} id="selectedRevenus" 
                      className={classes2.demiWidth} name="selectedRevenus" value={state.selectedRevenus} >
                      <MenuItem key={"Primaire"} value={"Primaire"} /*{...state.selectedRevenus === "Primaire" ? selected : null}*/>Primaire</MenuItem>
                      <MenuItem key={"Secondaire"} value={"Secondaire"} /*{...state.selectedRevenus === "Secondaire" ? selected : null}*/>Secondaire</MenuItem>
                      <MenuItem key={"Tempo"} value={"Tempo"}>Tempo</MenuItem>
                      <MenuItem key={"Rev_inconnus"} value={"Revenus inconnus"}>Revenus inconnus</MenuItem>
                    </Select>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={4}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="ctct_remarques"
                  id="ctct_remarques"
                  type="text"
                  label="Remarques"
                  variant="outlined"
                  fullWidth
                  style={{ marginTop: '1.1em' }} /></TableCell>
            </TableRow>
          </TableBody>
          </Table>
          <Button
            size="large"
            color="primary"
            variant="contained"
            //fullWidth
            className={classes2.buttons}
            type="submit"
  //          onClick={onSubmit/*handleSubmit(isEditMode ? handleUpdateContact : handleCreateContact)*/}
  //          disabled={submitLoading}
          >
              {isEditMode ? 'Mettre à jour le contact' : 'Créer le contact'}
          </Button>
        </form>
        {submitError && (
          <ErrorBox
            errorMsg={submitError}
            clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
        )}
      </div></></>
      );
    }

    function LogementForm() {
      let set: Array<occupationProps> = []
      //let currOccupation: occupationProps[]
      set.push({ siteId: "0", range: "0-10", nombre: 0, taux: 0 })
      set.push({ siteId: "0", range: "11-17", nombre: 0, taux: 0 })
      set.push({ siteId: "0", range: "18-24", nombre: 0, taux: 0 })
      set.push({ siteId: "0", range: "25-59", nombre: 0, taux: 0 })
      set.push({ siteId: "0", range: "60-74", nombre: 0, taux: 0 })
      set.push({ siteId: "0", range: ">74", nombre: 0, taux: 0 })
      if(currentData !== undefined) {
        let index = 10
        currentData?.tx_occupation?.map((line) => {
          console.log("LINE OCCUPATION: "+line)
          let tab = line.split("|")
          if(line.length >= 1) {
            if(tab[0] === "0-10") { index = 0 }
            else if(tab[0] === "11-17") { index = 1 }
            else if(tab[0] === "18-24") { index = 2 }
            else if(tab[0] === "25-59") { index = 3 }
            else if(tab[0] === "60-74") { index = 4 }
            else if(tab[0] === ">74") { index = 5 }
            else { index = 10 }
          //  set.push({siteId: currentData.id, range: tab[0], nombre: Number(tab[1].replace("nb ","")), taux: Number(tab[2].replace("poids ","")) })
            if(index !== 10) {
              set[index] = {siteId: currentData.id, range: tab[0], nombre: Number(tab[1].replace("nb ","")), taux: Number(tab[2].replace("poids ",""))}
            }
          }
        })
      }
      
  //    console.log("Date UPDATE: "+date_update)
      const { register, control, handleSubmit, errors } = useForm({
        mode: 'onChange', // onSubmit
        defaultValues:
        {
  //        scenario: "update",
          sn_site: currentData?.sn_site || '',
          site_id: currentData?.id || '',
          gmt_date: currentData?.gmt_date || '',
          //date_update: currentData?.date_update, //date_update, //currentData?.date_update || new Date(),
          /*date_instru: currentData?.date_instru || '',
          date_end: currentData?.date_end || undefined,*/
          occupy_0_10_nb: set[0]?.nombre || '',
          occupy_11_17_nb: set[1]?.nombre || '',
          occupy_18_24_nb: set[2]?.nombre || '',
          occupy_25_59_nb: set[3]?.nombre || '',
          occupy_60_74_nb: set[4]?.nombre || '',
          occupy_74_nb: set[5]?.nombre || '',
          occupy_0_10_tx: set[0]?.taux || '',
          occupy_11_17_tx: set[1]?.taux || '',
          occupy_18_24_tx: set[2]?.taux || '',
          occupy_25_59_tx: set[3]?.taux || '',
          occupy_60_74_tx: set[4]?.taux || '',
          occupy_74_tx: set[5]?.taux || '',
        //  occupation: Array.from(statOccupy[currentData?.id || "0"]) as occupationProps[],
          cpt_type: currentData?.cpt_type || '',
          type_inst_elec: currentData?.type_inst_elec || '',
          index_cpt_elec: currentData?.index_cpt_elec || '',
          index_cpt_hc: currentData?.index_cpt_hc || '',
          puiss_sscrite: currentData?.puiss_sscrite || '',
          prm_linky: currentData?.prm_linky || '',
          adresse: currentData?.adresse || '',
          code_postal: currentData?.code_postal || '',
          instrum_by: currentData?.instrum_by || '',
          surface: currentData?.surface || '',
          surf_unused: currentData?.surf_unused || '',
          surf_nonchauff: currentData?.surf_nonchauff || '',
          niveaux: currentData?.niveaux || '',
  //        date_update: currentData?.date_update || null,
          rq_instru: currentData?.rq_instru || '', // ? JSON.parse(currentData?.rq_instru) : '',
          chauff_nrj0: infosChauff?.[0].nrj || '',
          chauff_detail0: infosChauff?.[0].detail/*?.map((i) => i.length > 3 ? i+"," : null)*/ || [],
          chauff_rq0: infosChauff?.[0].rq || '',
          chauff_nrj1: infosChauff?.[1].nrj || '',
          chauff_detail1: infosChauff?.[1].detail || '',
          chauff_rq1: infosChauff?.[1].rq || '',
          chauff_nrj2: infosChauff?.[2].nrj || '',
          chauff_detail2: infosChauff?.[2].detail || '',
          chauff_rq2: infosChauff?.[2].rq || '',
          ecs_nrj0: infosEcs?.[0].nrj || '',
          //ecs_detail0: infosEcs?.[0].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
          ecs_detail0: ecsDetail?.[0]?.map((i) => i.length > 3 ? i+"," : null) || '',
          ecs_rq0: infosEcs?.[0].rq || '',
          ecs_nrj1: infosEcs?.[1].nrj || '',
          ecs_detail1: ecsDetail?.[1]?.map((i) => i.length > 3 ? i+"," : null) || '',
          //infosEcs?.[1].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
          ecs_rq1: infosEcs?.[1].rq || '',
          cuissonplq_rq0: infosPlaques?.[0].rq || '',
          cuissonplq_rq1: infosPlaques?.[1].rq || '',
/*          cuissonplq_nrj0: infosPlaques?.[0].type || '',
          cuissonplq_detail0: infosPlaques?.[0].nbFeux || '',
          cuissonplq_rq0: infosPlaques?.[0].rq || '',
          cuissonplq_nrj1: infosPlaques?.[1].type || '',
          cuissonplq_detail1: infosPlaques?.[1].nbFeux || '',
          cuissonplq_rq1: infosPlaques?.[1].rq || '',*/
          //four_type0: infosFour?.[0].type || '',
          four_detail0: infosFour?.[0].detail || '',
          four_rq0: infosFour?.[0].rq || '',
          //four_type1: infosFour?.[1].type || '',
          four_detail1: infosFour?.[1].detail || '',
          four_rq1: infosFour?.[1].rq || '',
          ventil_type0: infosVentil?.[0].type || '',
          ventil_detail0: infosVentil?.[0].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
          ventil_rq0: infosVentil?.[0].rq || '',
          ventil_type1: infosVentil?.[1].type || '',
          ventil_detail1: infosVentil?.[1].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
          ventil_rq1: infosVentil?.[1].rq || '',
          ventil_type2: infosVentil?.[2].type || '',
          ventil_detail2: infosVentil?.[2].detail || '',
          ventil_rq2: infosVentil?.[2].rq || '',
          clim_type0: infosClim?.[0].type || '',
          clim_detail0: infosClim?.[0].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
          clim_rq0: infosClim?.[0].rq || '',
          clim_type1: infosClim?.[1].type || '',
          clim_detail1: infosClim?.[1].detail?.map((i) => i.length > 3 ? i+"," : null) || '',
          clim_rq1: infosClim?.[1].rq || '',
/*          clim_type2: infosClim?.[2].type || '',
          clim_detail2: infosClim?.[2].detail || '',
          clim_rq2: infosClim?.[2].rq || '',*/
          piscine_infos_present: infosPiscine?.present || "",
          piscine_infos_type: infosPiscine.type || "",
          piscine_infos_chauffage: infosPiscine.chauffage || "",
          piscine_infos_lgdia: infosPiscine.longueurOrDiam || 0,
          piscine_infos_larg: infosPiscine.largeur || 0,
          piscine_infos_prof: infosPiscine.prof || 0,
          piscine_infos_consoppe: infosPiscine.consoPompe || "",
          piscine_infos_note: infosPiscine.note || "",
          chauff_id: currentData?.chauff_id,
          ecs_id: currentData?.ecs_id,
          ventil_id: currentData?.ventil_id,
          clim_id: currentData?.clim_id,
          piscine_id: currentData?.piscine_id,
          cuissonplq_id: currentData?.cuissonplq_id,
          four_id: currentData?.four_id,
          },
        });
      const [state, setState] = useState({
        //selectedRevenus: contact.revenus || "",
        contactID: contact?.id !== undefined ? contact.id : '',
        nature: currentData?.nature !== null ? currentData?.nature : 'Nature inconnue',
        dateEnd: currentData?.date_end || null,//undefined,
        dateInstru: currentData?.date_instru || null, //undefined,
        dateUpdate: currentData?.date_update || null,//date_update,//currentData?.date_update || new Date(),
        tarif_elec: currentData?.tarif_elec !== null ? currentData?.tarif_elec : 'Tarif inconnu',
        chauff_nrj0: infosChauff?.[0].nrj,
        chauff_detail0: infosChauff?.[0].detail/*?.map((i) => i.length > 3 ? i+"," : null)*/ || [],
        //chauff_detail0: infosChauff?.[0].detail !== undefined && infosChauff?.[0]?.detail.length > 1 ? infosChauff?.[0]?.detail[0].split(',')/*map((i) => i.length > 3 ? i+"," : "")*/ : /*[]*/ [],
        chauff_rq0: infosChauff?.[0].rq,
        chauff_nrj1: infosChauff?.[1].nrj,
        chauff_detail1: infosChauff?.[1].detail || [],
        chauff_rq1: infosChauff?.[1].rq,
        chauff_nrj2: infosChauff?.[2].nrj,
        chauff_detail2: infosChauff?.[2].detail || [],
//        chauff_detail2: infosChauff?.[2].detail !== undefined && infosChauff?.[2]?.detail.length > 1 ? infosChauff?.[2]?.detail[0].split(',')/*?.map((i) => i.length > 3 ? i+"," : "")*/ : /*[]*/ [],
//        chauff_detail2: infosChauff?.[2].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
        chauff_rq2: infosChauff?.[2].rq,
/*        cuissonplq_nrj0: infosPlaques?.[0].type || '',
        cuissonplq_detail0: infosPlaques?.[0].nbFeux || '',
        cuissonplq_nrj1: infosPlaques?.[1].type || '',
        cuissonplq_detail1: infosPlaques?.[1].nbFeux || '',
        cuissonplq_rq0: infosPlaques?.[0].rq || '',
        cuissonplq_rq1: infosPlaques?.[1].rq || '',*/
        four_type0: infosFour?.[0].type || '',
        four_type1: infosFour?.[1].type || '',
        ecs_nrj0: infosEcs?.[0].nrj,
//        ecs_detail0: infosEcs?.[0]?.detail !== undefined && infosEcs?.[0]?.detail.length > 1 ? infosEcs?.[0]?.detail[0].split(',')/*map((i) => i.length > 3 ? i+"," : "")*/ : /*[]*/ [],
        ecs_detail0: ecsDetail?.[0] || [],
//        ecs_detail0: infosEcs?.[0].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
        ecs_rq0: infosEcs?.[0].rq,
        ecs_nrj1: infosEcs?.[1].nrj,
        ecs_detail1: ecsDetail?.[1] || [],
        //ecs_detail1: infosEcs?.[1]?.detail !== undefined && infosEcs?.[1]?.detail.length > 1 ? infosEcs?.[1]?.detail[0].split(',')/*map((i) => i.length > 3 ? i+"," : "")*/ : /*[]*/ [],
        //ecs_detail1: infosEcs?.[1].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
        ecs_rq1: infosEcs?.[1].rq,
        ventil_type0: infosVentil?.[0].type,
        ventil_detail0: ventilDetail?.[0] || [],
        //ventil_detail0: infosVentil?.[0]?.detail !== undefined && infosVentil?.[0]?.detail.length > 1 ? infosVentil?.[0]?.detail[0].split(',')/*map((i) => i.length > 3 ? i+"," : "")*/ : /*[]*/ [],
        //ventil_detail0: infosVentil?.[0].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
        ventil_rq0: infosVentil?.[0].rq,
        ventil_type1: infosVentil?.[1].type,
        ventil_detail1: ventilDetail?.[1] || [],
        //ventil_detail1: infosVentil?.[1]?.detail !== undefined && infosVentil?.[1]?.detail.length > 1 ? infosVentil?.[1]?.detail[0].split(',')/*map((i) => i.length > 3 ? i+"," : "")*/ : /*[]*/ [],
        //ventil_detail1: infosVentil?.[1].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
        ventil_rq1: infosVentil?.[1].rq,
        clim_type0: infosClim?.[0].type,
        clim_detail0: climDetail?.[0] || [],
        //clim_detail0: infosClim?.[0]?.detail !== undefined && infosClim?.[0]?.detail.length > 1 ? infosClim?.[0]?.detail[0].split(',')/*map((i) => i.length > 3 ? i+"," : "")*/ : /*[]*/ [],
        //clim_detail0: infosClim?.[0].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
        clim_rq0: infosClim?.[0].rq,
        clim_type1: infosClim?.[1].type,
        clim_detail1: climDetail?.[1] || [],
        //clim_detail1: infosClim?.[1]?.detail !== undefined && infosClim?.[1]?.detail.length > 1 ? infosClim?.[1]?.detail[0].split(',')/*map((i) => i.length > 3 ? i+"," : "")*/ : /*[]*/ [],
//        clim_detail1: infosClim?.[1].detail?.map((i) => i.length > 3 ? i+"," : "") || [],
        clim_rq1: infosClim?.[1].rq,
        cuissonplq_nrj0: infosPlaques?.[0].type || '',
        cuissonplq_detail0: infosPlaques?.[0].nbFeux || '',
        cuissonplq_nrj1: infosPlaques?.[1].type || '',
        cuissonplq_detail1: infosPlaques?.[1].nbFeux || '',
        chauff_id: currentData?.chauff_id,
        ecs_id: currentData?.ecs_id,
        ventil_id: currentData?.ventil_id,
        clim_id: currentData?.clim_id,
        piscine_id: currentData?.piscine_id,
        cuissonplq_id: currentData?.cuissonplq_id,
        four_id: currentData?.four_id,
        piscine_infos_present: infosPiscine.present,
        piscine_infos_type: infosPiscine.type,
        piscine_infos_chauffage: infosPiscine.chauffage,
        selectedRevenus: contact.revenus !== null && contact.revenus.length > 4 ? contact.revenus : "Revenus inconnus",
    /*  
        four_type0: infosFour?.[0].type,
        four_detail0: infosFour?.[0].detail,
        four_rq0: infosFour?.[0].rq,
        four_type1: infosFour?.[1].type,
        four_detail1: infosFour?.[1].detail,
        four_rq1: infosFour?.[1].rq,*/
        /*piscine_infos_lgdia: infosPiscine.longueurOrDiam,
        piscine_infos_larg: infosPiscine.largeur,
        piscine_infos_prof: infosPiscine.prof,
        piscine_infos_consoppe: infosPiscine.consoPompe,
        piscine_infos_note: infosPiscine.note,*/
      });
    
      console.log("############ ECS DETAILS: "+state.ecs_detail0+" / "+state.ecs_detail1)
//      state.ecs_detail0[0].split(',').map((str) => console.log("############ ECS DETAILS0: "+str))
    /*  chauffFields?.find((cf) => String(cf.nrj) === String(state.chauff_nrj0))?.detail.map((j) => (
        state.chauff_detail0?.map((gg) => gg.split(',').map((s) =>
          console.log("ChauffDetails0: "+s)
        ))
      ))
      chauffFields?.find((cf) => String(cf.nrj) === String(state.chauff_nrj1))?.detail.map((j) => (
        state.chauff_detail1?.map((gg) => gg.split(',').map((s) =>
          console.log("ChauffDetails1: "+s)
        ))
      ))
      chauffFields?.find((cf) => String(cf.nrj) === String(state.chauff_nrj2))?.detail.map((j) => (
        state.chauff_detail2?.map((gg) => gg.split(',').map((s) =>
          console.log("ChauffDetails2: "+s)
        ))
      ))*/
      const selectChange = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
        console.log("################ e.taget.value: "+event.target.value)
        setState({ ...state, [event.target.name as string]: event.target.value })
  //      setSelected(event.target.value as String)
      }
      function handleDateChg(evt: { target: { value: any; name: any; }; }) {
        console.log("handleDateChg: "+evt.target.name+" "+evt.target.value);
        //console.log("Date formatted value: "+format(new Date(evt.target.value), "yyyy-MM-dd'T'h':'mm"))
        const value = evt.target.value;
    /*    console.log("DATE CHANGE VAL: "+value)
        let str = value.replace("T--:--","T12:00")
        console.log("DATE CHANGE VAL: "+str) */
        setState({ ...state, [evt.target.name]: value });
  //      setState({ ...state, [evt.target.name]: format(new Date(value), "yyyy-MM-dd'T'h':'mm") });
      }
      const hdlSetChauff = (event: React.ChangeEvent<{  name?: string | undefined; value: unknown; }>) => {
        console.log("hdlSetChauff EVENT: "+event.target.name+": "+event.target.value);
        //const key = event.target.name as keyof state

      /*  if(event.target.name as string === "chauff_nrj0") { state.chauff_detail0 = [] }
        if(event.target.name as string === "chauff_nrj1") { state.chauff_detail1 = [] }
        if(event.target.name as string === "chauff_nrj2") { state.chauff_detail2 = [] }
        if(event.target.name as string === "ecs_nrj0") { state.ecs_detail0 = [] }
        if(event.target.name as string === "ecs_nrj1") { state.ecs_detail1 = [] } */
        console.log("€€€"+state.chauff_detail1)
        setState({ ...state, [event.target.name as string]: event.target.value });
      }
      const onSubmit = handleSubmit((data/*{ firstName, lastName, age }*/) => {
        /*console.log(data)
        console.log(state)*/
        console.log("On SUBMIT called !?)")
        const TxOccupation: Array<string> = []
        TxOccupation[0] = "0-10|nb "+data.occupy_0_10_nb+"|poids "+String(data.occupy_0_10_tx)
        TxOccupation[1] = "11-17|nb "+data.occupy_11_17_nb+"|poids "+String(data.occupy_11_17_tx)
        TxOccupation[2] = "18-24|nb "+data.occupy_18_24_nb+"|poids "+String(data.occupy_18_24_tx)
        TxOccupation[3] = "25-59|nb "+data.occupy_25_59_nb+"|poids "+String(data.occupy_25_59_tx)
        TxOccupation[4] = "60-74|nb "+data.occupy_60_74_nb+"|poids "+String(data.occupy_60_74_tx)
        TxOccupation[5] = ">74|nb "+data.occupy_74_nb+"|poids "+String(data.occupy_74_tx)
        console.log(TxOccupation.map((t)=>t+"#"));
        const separator = ['+']
        const logement : SitePayload = {
          id: currentData?.id ? currentData?.id : '',   // !== undefnid ? length > 0
          siteId: data.site_id,
          sn_site: data.sn_site,
          adresse: data.adresse,
          contacts: currentData?.contacts,
          contactId: String(state.contactID) || '',
          date_instru: state.dateInstru,// || undefined,
          date_end: state.dateEnd,// || undefined,
          date_update: state.dateUpdate || new Date(),//null,//new Date(), //state.dateUpdate || new Date(),//data.date_update, 
          concentrateur: currentData?.concentrateur,
          gmt_date: Number(data.gmt_date),
          tx_occupation: TxOccupation,
          type_inst_elec: data.type_inst_elec,
          index_cpt_elec : Number(data.index_cpt_elec),
          index_cpt_hc : Number(data.index_cpt_hc),
          tarif_elec : state.tarif_elec,
          puiss_sscrite : String(data.puiss_sscrite),
          prm_linky : Number(data.prm_linky),
          code_postal : Number(data.code_postal),
          instrum_by : data.instrum_by,
          nature : state.nature,
          surface : Number(data.surface),
          surf_unused : Number(data.surf_unused),
          surf_nonchauff : Number(data.surf_nonchauff),
          niveaux : Number(data.niveaux),
          rq_instru : data.rq_instru, //JSON.stringify(data.rq_instru),
          chauff_nrj : [state.chauff_nrj0 || '',state.chauff_nrj1 || '',state.chauff_nrj2 || ''],
          //chauff_detail : [state.chauff_detail0/*.flatMap((d)=>d).join(',')*/ || [],state.chauff_detail1/*?.flatMap((d)=>d).join(',')*/ || '',state.chauff_detail2/*?.flatMap((d)=>d).join(',')*/ || ''],
          //chauff_detail : (state.chauff_detail0 || []).concat(separator, state.chauff_detail1 || [], state.chauff_detail2 || []),
          chauff_detail : [state.chauff_detail0?.flatMap((d)=>d).join('+') || '', state.chauff_detail1?.flatMap((d)=>d).join('+') || '', state.chauff_detail2?.flatMap((d)=>d).join('+') || ''],
          chauff_rq : [String(data.chauff_rq0) || '',String(data.chauff_rq1) || '',String(data.chauff_rq2) || ''],
          ecs_nrj : [state.ecs_nrj0 || '',state.ecs_nrj1 || ''],
          //ecs_detail : (state.ecs_detail0 || []).concat(state.ecs_detail1 || []),
          ecs_detail : [state.ecs_detail0?.flatMap((d)=>d).join('+') || '', state.ecs_detail1?.flatMap((d)=>d).join('+') || ''],
          ecs_rq : [String(data.ecs_rq0) || '',String(data.ecs_rq1) || ''],
          ventil_type : [state.ventil_type0 || '',state.ventil_type1 || ''],
          //ventil_detail : [state.ventil_detail0?.flatMap((d)=>d).join(',') || '',state.ventil_detail1?.flatMap((d)=>d).join(',') || ''],
          ventil_detail : [state.ventil_detail0?.flatMap((d)=>d).join('+') || '', state.ventil_detail1?.flatMap((d)=>d).join('+') || ''],
          //ventil_detail : (state.ventil_detail0 || []).concat(state.ventil_detail1 || []),
          ventil_rq : [String(data.ventil_rq0) || '',String(data.ventil_rq1) || ''],
          clim_type : [state.clim_type0 || '',state.clim_type1 || ''],
          //clim_detail : [state.clim_detail0?.flatMap((d)=>d).join(',') || '',state.clim_detail1?.flatMap((d)=>d).join(',') || ''],
          clim_detail : [state.clim_detail0?.flatMap((d)=>d).join('+') || '', state.clim_detail1?.flatMap((d)=>d).join('+') || ''],
          //clim_detail : (state.clim_detail0 || []).concat(state.clim_detail1 || []),
          clim_rq : [String(data.clim_rq0) || '',String(data.clim_rq1) || ''],
          piscine_infos : [String(state.piscine_infos_present) || '',
            String(state.piscine_infos_type) || '',
            String(state.piscine_infos_chauffage) || '',
            String(data.piscine_infos_lgdia) || '',
            String(data.piscine_infos_larg) || '',
            String(data.piscine_infos_prof) || '',
            String(data.piscine_infos_consoppe) || '',
            String(data.piscine_infos_note) || ''
          ],
          cuissonplq_nrj : [String(state.cuissonplq_nrj0) || '', String(state.cuissonplq_nrj1) || ''],
          cuissonplq_detail : [state.cuissonplq_detail0 ||'', state.cuissonplq_detail1 || ''],
          cuissonplq_rq : [String(data.cuissonplq_rq0) || '', String(data.cuissonplq_rq1) || ''],
          four_type : [state.four_type0 || '',state.four_type1 || ''],
          four_detail : [String(data.four_detail0) || '', String(data.four_detail1) || ''],
          four_rq : [String(data.four_rq0) || '', String(data.four_rq1) || ''],
          veilles_app : currentData?.veilles_app,
          veilles_pw : currentData?.veilles_pw,
          veilles_rq : currentData?.veilles_rq,
          cpt_type : currentData?.cpt_type,
          chauff_id: [state.chauff_id?.flatMap((d)=>d).join(',') || ''],
        //  chauff_id: state.chauff_id !== undefined ? Array<Number>(state.chauff_id?.flatMap((d)=>(parseInt(d)))) : '',
          ecs_id: [state.ecs_id?.flatMap((d)=>d).join(',') || ''],
          ventil_id: [state.ventil_id?.flatMap((d)=>d).join(',') || ''],
          clim_id: [state.clim_id?.flatMap((d)=>d).join(',') || ''],
          piscine_id: [state.piscine_id?.flatMap((d)=>d).join(',') || ''],
          cuissonplq_id: [state.cuissonplq_id?.flatMap((d)=>d).join(',') || ''],
          four_id: [state.four_id?.flatMap((d)=>d).join(',') || ''],
        }
        console.log("Logement: "+logement.ecs_id)
        /*if(!isEditMode) {
          dispatch(createNewSite(logement))//, closeDialog))
        } else {*/
          if(selectedScenario === "creation"){   // && siteId !== undefined
            dispatch(updateSite(logement.id, logement, closeDialog))
//            window.location.reload()
          } 
          if(selectedScenario === "update") { 
            dispatch(modifySite(logement.id, logement, closeDialog ))//, window.location.reload()))
          //  window.location.reload()
            }
  //      }
      });

      return (
      <div className={classes2.TopDivider}>
        <form onSubmit={onSubmit}>
          <h4>Pour les infos logement, choisissez un mode de modification :</h4>
          <div style={{ maxWidth: '100%', height: '10rem' }}>
          { isEditMode ?
          (<Controller
            style={{ maxWidth: '35vw' }}
            control={control}
            name="controlUpdateOrCreate"
            as={
              <FormControl className={classes.radioGroupForm}>
                <RadioGroup className={classes.radioGroup}
                  aria-labelledby="radio-buttons-group-label"
                  name="scenario"
                  value={selectedScenario} 
                  onChange={radioHandlerScenar}
                  >
                  <div className={classes.formControlLabels}>
                    <FormControlLabel
                      value="update"
                      control={<Radio color="primary" />}
                      label="Mettre à jour les infos à la date"
                    />
                    <FormControlLabel
                      value="creation"
                      control={<Radio color="primary" />}
                      label="Créer une nouvelle vue datée"
                    />
                  </div>
                </RadioGroup>
              </FormControl>
            }
          />) : null }
          { selectedScenario !== "" ?
          (<Button
          size="large"
          color="primary"
          variant="contained"
          //fullWidth
          className={classes.submitBtn}
          type="submit"
          disabled={submitLoading}
        >
          { !isEditMode ?
              'Créer le logement à la date d\'état'
              : selectedScenario === "update" ?
                'Mettre à jour le couple date/état du logement' 
                : 'Créer une nouvelle vue à la date d\'état'}
        </Button>
        ) : null }
        {submitError && (
          <ErrorBox
            errorMsg={submitError}
            clearErrorMsg={() => dispatch(clearSubmitSiteError())} />
        )}
        { selectedScenario !== "" ?
        (<TextField margin='dense'
          //className={MoreClasses?.tiersWidth}
          inputRef={register}
          id="date_update"
          name="dateUpdate"
          type="datetime-local"
          label="Date d'état infos"
          variant="outlined"
          onChange={handleDateChg}
        //  defaultValue={format(state.dateUpdate, "yyyy-MM-dd'T'h':'mm")}
    //          defaultValue={format(new Date(state.dateUpdate), "yyyy-MM-dd'T'h':'mm")}
          value={format(new Date(state.dateUpdate), "yyyy-MM-dd'T'h':'mm")}
    //          value={currentData?.date_update/*format(new Date(state.dateUpdate), "yyyy-MM-dd'T'h':'mm")*/}
          style={{ marginRight: '8rem', top: '0.53rem', marginTop: '1.1em', float: 'right' }}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={selectedScenario === "update" && state.dateUpdate !== null ? true : false}
          />) : null }
        </div>
        { selectedScenario !== "" ? 
        ( <><Typography
            variant={isMobile ? 'h5' : 'h4'}
            color="secondary"
            style={{ marginRight: '0.2em', marginTop: '1.5rem' }}
          >Logement <IconDashboard className={classes2.customIcon} />
          </Typography><br/>
          <Table className={classes2.contactDetailsTable}>
            <TableBody>
              <TableRow>
                <TableCell>
                  <TextField
                    inputRef={register}
                    name="sn_site"
                    //fullWidth
                    type="text"
                    label="N° de logement"
                    variant="outlined"
                  />
                </TableCell>
                <TableCell><TextField
                  //className={classes.fieldMargin}
                  type="datetime-local"
                  inputRef={register}
                  name="dateInstru"
                  id="date_instru"
                  onChange={handleDateChg}
                  //value={format(new Date(currentData?.date_instru || new Date()), "yyyy-MM-dd'T'h':'mm")}
                  defaultValue={format(new Date(state.dateInstru), "yyyy-MM-dd'T'h':'mm")}
                  label="Date instrumentation"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                /></TableCell>
                <TableCell><TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="gmt_date"
                  type="text"
                  label="GMT (1 ou 2)"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  /></TableCell>
                <TableCell><TextField
                  //className={classes.fieldMargin}
                  type="datetime-local"
                  inputRef={register}
                  id="date_end"
                  name="dateEnd"
                  /*value={format(new Date(currentData?.date_end || new Date()), "yyyy-MM-dd'T'h':'mm")}*/
                  onChange={handleDateChg}
                  defaultValue={format(new Date(state.dateEnd), "yyyy-MM-dd'T'h':'mm")}
                  label="Date de fin du logement"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                /></TableCell>
              </TableRow>
                <TableRow>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="cpt_type"
                    type="text"
                    label="Type compteur élec."
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="type_inst_elec"
                    type="text"
                    label="Type installation élec."
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                  /></TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="index_cpt_elec"
                    type="text"
                    label="Index cpt élec."
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="index_cpt_hc"
                    type="text"
                    label="Index cpt HC"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Select style={{top: '0.4rem', width: '14.15rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                      id="tarif_elec" margin="dense" variant="outlined" onChange={hdlSetChauff}
                      className={classes2.demiWidth} value={state.tarif_elec} name="tarif_elec">
                      <MenuItem key={"Simple_tarif"} value={"Simple tarif"} {/*...state*/...currentData?.tarif_elec === "Simple Tarif" ? 'selected' : null}>Simple tarif</MenuItem>
                      <MenuItem key={"Double_tarif"} value={"Double tarif"} {...state.tarif_elec === "Double Tarif" ? 'selected' : null}>Double tarif</MenuItem>
                      <MenuItem key={"Tarif_inconnu"} value={"Tarif inconnu"} /*{...state.tarif_elec === "Tarif inconnu" ? 'selected' : null}*/>Tarif élec inconnu</MenuItem>
                    </Select>
                  </TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="puiss_sscrite"
                    type="text"
                    label="Puissance souscrite"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="prm_linky"
                    type="text"
                    label="PRM Linky"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="adresse"
                    type="text"
                    label="Adresse"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="code_postal"
                    type="text"
                    label="Code postal"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="instrum_by"
                    type="text"
                    label="Instrumenté / Visité par"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                  <TableCell>
                    <Select style={{top: '0.33rem', width: '14.15rem'}} inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                      margin="dense" variant="outlined" onChange={selectChange} id="nature"  
                      className={classes2.demiWidth} name="nature" value={state.nature} >
                      <MenuItem key={"Maison"} value={"Maison"} /*{...state.nature === "Maison" ? selected : null}*/>Maison</MenuItem>
                      <MenuItem key={"Appartement"} value={"Appartement"} /*{...state.nature === "Appartement" ? selected : null}*/>Appartement</MenuItem>)
                      <MenuItem key={"Nature_inconnue"} value={"Nature inconnue"} >Nature inconnue</MenuItem>
                    </Select>
                  </TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="surface"
                    type="text"
                    label="Surface"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="surf_unused"
                    type="text"
                    label="Surf. non utilisée"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="surf_nonchauff"
                    type="text"
                    label="Surf. non chauffée"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                  <TableCell><TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    name="niveaux"
                    type="text"
                    label="Nb niveaux"
                    variant="outlined"
                    style={{ marginTop: '1.1em' }}
                    /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={4} >
                  <TextField margin='dense'
                    //className={MoreClasses?.tiersWidth}
                    inputRef={register}
                    multiline
                    name="rq_instru"
                    type="text"
                    rows={6}
                    label="Notes d'instrumentation"
                    variant="outlined"
                    style={{ marginTop: '1.1em', width: '100%' }}
                    /></TableCell>
                </TableRow>
              </TableBody>
          </Table>
          <Table style={{ marginRight: '0.2em', marginTop: '1em', width: '100%' }}
            className={classes2.siteDetailsTable}>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell colSpan={1}>
                Âges
              </TableCell>
              <TableCell colSpan={2}>
                0-10
              </TableCell>
              <TableCell colSpan={2}>
                11-17
              </TableCell>
              <TableCell colSpan={2}>
                18-24
              </TableCell>
              <TableCell colSpan={2}>
                25-59
              </TableCell>
              <TableCell colSpan={2}>
                60-74
              </TableCell>
              <TableCell colSpan={2}>
                &gt;74
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          <TableRow>
          <TableCell className="vert" rowSpan={3} style={{ padding: '0' }}>
            <Typography
              color="secondary"
            >Occupation
            </Typography>
          </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={1}>
              Nombre
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_0_10_nb"
                type="text"
                variant="outlined"
                defaultValue={set.find((s)=>s.range === "0-10")?.nombre || 0/*currOccupation.find((co) => co.range === "0-10")?.nombre*/}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_11_17_nb"
                type="text"
                variant="outlined"
                defaultValue={set.find((s)=>s.range === "11-17")?.nombre || 0}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_18_24_nb"
                type="text"
                variant="outlined"
                defaultValue={set.find((s)=>s.range === "18-24")?.nombre || 0}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_25_59_nb"
                type="text"
                variant="outlined"
                defaultValue={set.find((s)=>s.range === "25-59")?.nombre || 0}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_60_74_nb"
                type="text"
                variant="outlined"
                defaultValue={set.find((s)=>s.range === "60-74")?.nombre || 0}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_74_nb"
                type="text"
                variant="outlined"
                defaultValue={set.find((s)=>s.range === ">74")?.nombre || 0}
                //onChange={handleChange}
              />
            </TableCell>
            </TableRow>
            <TableRow className={classes2.lastTrSiteDetails}>
            <TableCell colSpan={1}>
              Temps présence (%)
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_0_10_tx"
                type="text"
                variant="outlined"
                defaultValue={(set.find((s)=>s.range === "0-10")?.taux || 0)*100}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_11_17_tx"
                type="text"
                variant="outlined"
                defaultValue={(set.find((s)=>s.range === "11-17")?.taux ||0)*100}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_18_24_tx"
                type="text"
                variant="outlined"
                defaultValue={(set.find((s)=>s.range === "18-24")?.taux ||0)*100}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_25_59_tx"
                type="text"
                variant="outlined"
                defaultValue={(set.find((s)=>s.range === "25-59")?.taux ||0)*100}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_60_74_tx"
                type="text"
                variant="outlined"
                defaultValue={(set.find((s)=>s.range === "60-74")?.taux ||0)*100}
                //onChange={handleChange}
              />
            </TableCell>
            <TableCell colSpan={2}>
              <TextField margin='dense'
                //className={MoreClasses?.tiersWidth}
                inputRef={register}
                name="occupy_74_tx"
                type="text"
                variant="outlined"
                defaultValue={(set.find((s)=>s.range === ">74")?.taux ||0)*100}
                //onChange={handleChange}
              />
            </TableCell>
            </TableRow>
          </TableBody>
          </Table>
          <Table style={{ marginRight: '0.2em', marginTop: '1em', width: '100%' }} className={classes2.siteDetailsTable}>
            <TableHead>
              <TableRow>
                <TableCell colSpan={1}></TableCell>
                <TableCell colSpan={1} style={{ backgroundColor: 'transparent' }}>
                </TableCell>
                <TableCell colSpan={2}>
                  Principal
                </TableCell>
                <TableCell colSpan={2}>
                  Secondaire
                </TableCell>
                <TableCell colSpan={2}>
                  Appoint
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            <TableRow>
              <TableCell className="vert" rowSpan={5} style={{ padding: '0' }}>
                <Tooltip data-html={true} title={<>{infosChauff?.map((i,index) => <h3 key={"chauff"+index+"_"+i.nrj+i.detail}>{"#"+(index+1)+": "+i.nrj+" / "+i.detail+" / "+i.rq}</h3>)}</>}>
                  <InfoIcon style={{right: '0.1rem', bottom: '0.3rem', position: 'relative', 
                    color: infosChauff.length > 0 ? 'primary' : 'transparent' }} /> 
                </Tooltip>
                <Typography
                  color="secondary"
                >Chauffage
                </Typography>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Énergie
              </TableCell>
              <TableCell colSpan={2}>
                <Select /*displayEmpty defaultValue={currSite_id}*/
                  /*id="chauff_nrj0"*/ margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.chauff_nrj0} name="chauff_nrj0"
                  >
                  {chauffFields.map((u) => ( state.chauff_nrj0 !== u.nrj ?
                    <MenuItem key={u.nrj+"_chfnrj0"} value={u.nrj}>{u.nrj}</MenuItem>
                    : <MenuItem key={u.nrj+"_chfnrj0"} value={u.nrj} selected><em>{u.nrj}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell colSpan={2}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/
                  /*id="chauff_nrj1"*/ margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.chauff_nrj1} name="chauff_nrj1"
                  >
                  {chauffFields.map((u) => ( state.chauff_nrj1 !== u.nrj ?
                    <MenuItem key={u.nrj+"_chfnrj1"} value={u.nrj}>{u.nrj}</MenuItem>
                    : <MenuItem key={u.nrj+"_chfnrj1"} value={u.nrj} selected><em>{u.nrj}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell colSpan={2}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/
                  /*id="chauff_nrj2"*/ margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.chauff_nrj2} name="chauff_nrj2"
                  >
                  {chauffFields.map((u) => ( state.chauff_nrj2 !== u.nrj ?
                    <MenuItem key={u.nrj+"_chfnrj2"} value={u.nrj}>{u.nrj}</MenuItem>
                    : <MenuItem key={u.nrj+"_chfnrj2"} value={u.nrj} selected><em>{u.nrj}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Détails
              </TableCell>
              <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
                <Select  multiple margin="dense" variant="outlined" onChange={hdlSetChauff} className={classes2.demiWidth}
                  name="chauff_detail0" value={state.chauff_detail0?.map((k) => k) || []}>
                  { chauffFields?.find((cf) => String(cf.nrj) === String(state.chauff_nrj0))?.detail.map((j) => (
                    <MenuItem key={j+"chDet_0"} value={j}>{j}</MenuItem> )
                  )}
                </Select>
              </TableCell>
              <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined" /*multiple*/
                  onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="chauff_detail1"
                  value={state.chauff_detail1?.map((k) => k) || []/*infosChauff[1].detail*//*infosChauff*//*infosChauff[0].detail[0]*//*chauffDetail[0][0] ? chauffDetail[0][0] : ""*//* state.chauff_nrj0.find((ic) => ic.nrj === infosChauff[0].nrj)?.detail*/}>
                  { chauffFields?.find((cf) => String(cf.nrj) === String(state.chauff_nrj1))?.detail.map((j) => (
                    <MenuItem key={j+"chDet_1"} value={j}>{j}</MenuItem>)
                  )}
                </Select>
              </TableCell>
              <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined" /*multiple*/
                  onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="chauff_detail2"
                  value={state.chauff_detail2?.map((k) => k) || []}//?.map((k) => k) || []/*infosChauff[1].detail*//*infosChauff*//*infosChauff[0].detail[0]*//*chauffDetail[0][0] ? chauffDetail[0][0] : ""*//* state.chauff_nrj0.find((ic) => ic.nrj === infosChauff[0].nrj)?.detail*/}
                  >
                  { chauffFields?.find((cf) => String(cf.nrj) === String(state.chauff_nrj2))?.detail.map((j) => (
                    <MenuItem key={j+"chDet_2"} value={j}>{j}</MenuItem>
                  /* infosChauff[1].detail?.map((c) => c !== j ?
                    <MenuItem key={j+"_1"} value={j}>{j}</MenuItem>
                    : <MenuItem key={j+"_1"} value={j} selected><em>{j}</em></MenuItem>*/ )
                  )}
                </Select>
                </TableCell>  
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Notes
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="chauff_rq0"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="chauff_rq1"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="chauff_rq2"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              </TableRow>
              <TableRow className={classes2.lastTrSiteDetails}>
              <TableCell>Appareils liés</TableCell>
              <TableCell colSpan={5}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined" style={{maxWidth: '22rem', minWidth: '28rem' }}
                  onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="chauff_id"
                  value={state.chauff_id || []}>
                  { equipements.filter((e) => e.poste.name === "CVC").map((eq) => 
                    eq.voies2mesures.length > 0 ?
                    <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;<b>{eq.voies2mesures[0]?.id_conc+"/"
                      +eq.voies2mesures[0]?.id_module+"-v"+eq.voies2mesures[0]?.number+" "}</b>&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                      {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>
                    : <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                      {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>)}
                </Select>
              </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Table style={{ marginRight: '0.2em', marginTop: '1em', width: '100%' }}
              className={classes2.siteDetailsTable}>
            <TableHead>
              <TableRow>
                <TableCell colSpan={1}>
                </TableCell>
                <TableCell colSpan={1} style={{ backgroundColor: 'transparent' }}>
                </TableCell>
                <TableCell colSpan={2}>
                  Principal
                </TableCell>
                <TableCell colSpan={2}>
                  Secondaire
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            <TableRow>
            <TableCell className="vert" rowSpan={5} style={{ padding: '0' }}>
              <Tooltip data-html={true} title={<>{infosEcs?.map((i,index) => <h3 key={(index+1)+i.nrj+i.detail}>{"#"+(index+1)+": "+i.nrj+" / "+i.detail+" / "+i.rq}</h3>)}</>}>
                <InfoIcon style={{right: '0.1rem', bottom: '0.3rem', position: 'relative', 
                  color: infosEcs.length > 0 ? 'primary' : 'transparent' }} /> 
              </Tooltip>
              <Typography
                color="secondary"
              >ECS
              </Typography>
            </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={1}>
                Énergie
              </TableCell>
              <TableCell colSpan={2}>
                <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.ecs_nrj0} name="ecs_nrj0" >
                  {ecsFields.nrj.map((e) =>
                    <MenuItem key={e+"_ecs0"} value={e}>{e}</MenuItem>
                  )}
                </Select>
              </TableCell>
              <TableCell colSpan={2}>
                <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.ecs_nrj1} name="ecs_nrj1">
                  {ecsFields.nrj.map((e) =>
                    <MenuItem key={e+"_ecs1"} value={e}>{e}</MenuItem>
                  )}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Détails
              </TableCell>
              <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined" /*multiple*/
                  onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="ecs_detail0"
                  value={state.ecs_detail0?.map((k) => k) || []/*infosChauff[1].detail*//*infosChauff*//*infosChauff[0].detail[0]*//*chauffDetail[0][0] ? chauffDetail[0][0] : ""*//* state.chauff_nrj0.find((ic) => ic.nrj === infosChauff[0].nrj)?.detail*/}>
                  {ecsFields?.detail.map((d) => <MenuItem key={d+"_ecsdet0"} value={d}>{d}</MenuItem>)}
                </Select>
                {/*<Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.ecs_detail0[0]?.split(',') || []} name="ecs_detail0">
                  {ecsFields?.detail.map((d) => <MenuItem key={d+"_ecsdet0"} value={d}>{d}</MenuItem>)}
                </Select>*/}
              </TableCell>
              <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
                <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.ecs_detail1?.map((k) => k) || []} name="ecs_detail1">
                  {ecsFields?.detail.map((d) => <MenuItem key={d+"_ecsdet1"} value={d}>{d}</MenuItem>)}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Notes
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="ecs_rq0"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="ecs_rq1"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              </TableRow>
              <TableRow className={classes2.lastTrSiteDetails}>
              <TableCell>Appareils liés</TableCell>
              <TableCell colSpan={3} style={{ maxWidth: '18rem' }}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined" style={{maxWidth: '22rem', minWidth: '28rem' }}
                  onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="ecs_id"
                  value={state.ecs_id || []}>
                  { equipements.filter((e) => e.poste.name === "CVC").map((eq) => 
                    eq.voies2mesures.length > 0 ?
                    <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;<b>{eq.voies2mesures[0]?.id_conc+"/"
                      +eq.voies2mesures[0]?.id_module+"-v"+eq.voies2mesures[0]?.number+" "}</b>&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                      {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>
                    : <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                      {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>)}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell className="vert" rowSpan={5} style={{ padding: '0' }}>
              <Tooltip data-html={true} title={<>{infosPlaques?.map((i,index) => <h3 key={(index+1)+i.nbFeux+i.type}>{"#"+(index+1)+": "+i.type+" / "+i.nbFeux+" / "+i.rq}</h3>)}</>}>
                <InfoIcon style={{right: '0.1rem', bottom: '0.3rem', position: 'relative', 
                  color: infosPlaques.length > 0 ? 'primary' : 'transparent' }} /> 
              </Tooltip>
                <Typography
                  color="secondary"
                >Cuisson
                </Typography>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Énergie plaques
              </TableCell>
              <TableCell colSpan={2}>
                <Select inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                  id="cuissonplq_nrj0" margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} //defaultValue={infosPlaques[0].type} 
                  value={state.cuissonplq_nrj0} name="cuissonplq_nrj0">
                  {plaquesFields.type.map((u) => ( infosPlaques[0].type !== u ?
                    <MenuItem key={u+"_0"} value={u}>{u}</MenuItem>
                    : <MenuItem key={u+"_0"} value={u} selected><em>{u}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell colSpan={2}>
                <Select inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                  id="cuissonplq_nrj1" margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} //defaultValue={infosPlaques[1].type}
                  value={state.cuissonplq_nrj1} name="cuissonplq_nrj1">
                  {plaquesFields.type.map((u) => ( infosPlaques[1].type !== u ?
                    <MenuItem key={u+"_1"} value={u}>{u}</MenuItem>
                    : <MenuItem key={u+"_1"} value={u} selected><em>{u}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Nombre de feux
              </TableCell>
              <TableCell colSpan={2}>
              <Select inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                  id="cuissonplq_detail0" margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} //defaultValue={infosPlaques[0].nbFeux}
                  value={state.cuissonplq_detail0} name="cuissonplq_detail0">
                  {plaquesFields.nbFeux.map((u) => ( infosPlaques[0].nbFeux !== u ?
                    <MenuItem key={u+"_0"} value={u}>{u}</MenuItem>
                    : <MenuItem key={u+"_0"} value={u} selected><em>{u}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell colSpan={2}>
              <Select inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                  id="cuissonplq_detail1" margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} //defaultValue={infosPlaques[1].nbFeux}
                  value={state.cuissonplq_detail1} name="cuissonplq_detail1">
                  {plaquesFields.nbFeux.map((u) => ( infosPlaques[1].nbFeux !== u ?
                    <MenuItem key={u+"_1"} value={u}>{u}</MenuItem>
                    : <MenuItem key={u+"_1"} value={u} selected><em>{u}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Notes
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="cuissonplq_rq0"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="cuissonplq_rq1"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              </TableRow>
              <TableRow className={classes2.lastTrSiteDetails}>
              <TableCell>Appareils liés</TableCell>
              <TableCell colSpan={3} style={{ maxWidth: '18rem' }}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined" style={{maxWidth: '22rem', minWidth: '28rem' }}
                  onChange={hdlSetChauff} className={classes2.demiWidth} name="cuissonplq_id"
                  value={state.cuissonplq_id || []}>
                  { equipements.filter((e) => e.poste.name === "Cuisson").map((eq) => 
                  eq.voies2mesures.length > 0 ?
                    <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;<b>{eq.voies2mesures[0]?.id_conc+"/"
                      +eq.voies2mesures[0]?.id_module+"-v"+eq.voies2mesures[0]?.number+" "}</b>&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                      {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>
                    : <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                      {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>)}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell className="vert" rowSpan={5} style={{ padding: '0' }}>
                <Tooltip data-html={true} title={<>{infosFour?.map((i,index) => <h3 key={(index+1)+i.type+i.detail}>{"#"+(index+1)+": "+i.type+" / "+i.detail+" / "+i.rq}</h3>)}</>}>
                  <InfoIcon style={{right: '0.1rem', bottom: '0.3rem', position: 'relative', 
                    color: infosFour.length > 0 ? 'primary' : 'transparent' }} /> 
                </Tooltip>    
                <Typography
                  color="secondary"
                >Four
                </Typography>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Type
              </TableCell>
              <TableCell colSpan={2}>
                <Select inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                  id="four_type0" margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} //defaultValue={infosFour[0].type}
                  value={state.four_type0} name="four_type0">
                  {fourFields.type.map((u) => ( infosFour[0].type !== u ?
                    <MenuItem key={u+"_0"} value={u}>{u}</MenuItem>
                    : <MenuItem key={u+"_0"} value={u} selected><em>{u}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell colSpan={2}>
                <Select inputRef={register} /*displayEmpty defaultValue={currSite_id}*/
                  id="four_type1" margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} //defaultValue={infosFour[1].type}
                  value={state.four_type1} name="four_type1">
                  {fourFields.type.map((u) => ( infosFour[1].type !== u ?
                    <MenuItem key={u+"_1"} value={u}>{u}</MenuItem>
                    : <MenuItem key={u+"_1"} value={u} selected><em>{u}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Détails
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="four_detail0"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="four_detail1"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Remarque
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="four_rq0"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="four_rq1"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              </TableRow>
              <TableRow className={classes2.lastTrSiteDetails}>
              <TableCell>Appareils liés</TableCell>
              <TableCell colSpan={3} style={{ maxWidth: '18rem' }}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined" style={{maxWidth: '22rem', minWidth: '28rem' }}
                  onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="four_id"
                  value={state.four_id || []}>
                  { equipements.filter((e) => e.poste.name === "Cuisson").map((eq) => 
                  eq.voies2mesures.length > 0 ?
                  <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;<b>{eq.voies2mesures[0]?.id_conc+"/"
                    +eq.voies2mesures[0]?.id_module+"-v"+eq.voies2mesures[0]?.number+" "}</b>&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                    {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>
                  : <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                    {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>)}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell className="vert" rowSpan={5} style={{ padding: '0' }}>
                <Tooltip data-html={true} title={<>{infosVentil?.map((i,index) => <h3 key={(index+1)+i.type!+i.detail}>{"#"+(index+1)+": "+i.type+" / "+i.detail+" / "+i.rq}</h3>)}</>}>
                  <InfoIcon style={{right: '0.1rem', bottom: '0.3rem', position: 'relative', 
                    color: infosVentil.length > 0 ? 'primary' : 'transparent' }} /> 
                </Tooltip>
                <Typography
                  color="secondary"
                >Ventilation
                </Typography>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Type
              </TableCell>
              <TableCell colSpan={2}>
                <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.ventil_type0} name="ventil_type0">
                  {ventilFields.type.map((u) => ( infosVentil[0].type !== u ?
                    <MenuItem key={u+"_0"} value={u}>{u}</MenuItem>
                    : <MenuItem key={u+"_0"} value={u} selected><em>{u}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell colSpan={2}>
                <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.ventil_type1} name="ventil_type1">
                  {ventilFields.type.map((u) => ( infosVentil[1].type !== u ?
                    <MenuItem key={u+"_1"} value={u}>{u}</MenuItem>
                    : <MenuItem key={u+"_1"} value={u} selected><em>{u}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Détails
              </TableCell>
              <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
                <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.ventil_detail0?.map((k) => k) || []} name="ventil_detail0">
                  {ventilFields?.detail.map((d) => <MenuItem key={d+"_0"} value={d}>{d}</MenuItem>)}
                </Select>
              </TableCell>
              <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
                <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.ventil_detail1?.map((k) => k) || []} name="ventil_detail1">
                  {ventilFields?.detail.map((d) => <MenuItem key={d+"_1"} value={d}>{d}</MenuItem>)}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Remarque
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="ventil_rq0"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="ventil_rq1"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              </TableRow>
              <TableRow className={classes2.lastTrSiteDetails}>
              <TableCell>Appareils liés</TableCell>
              <TableCell colSpan={3} style={{ maxWidth: '18rem' }}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined" style={{maxWidth: '22rem', minWidth: '28rem' }}
                  onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="ventil_id"
                  value={state.ventil_id || []}>
                  { equipements.filter((e) => e.poste.name === "CVC").map((eq) => 
                  eq.voies2mesures.length > 0 ?
                  <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;<b>{eq.voies2mesures[0]?.id_conc+"/"
                    +eq.voies2mesures[0]?.id_module+"-v"+eq.voies2mesures[0]?.number+" "}</b>&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                    {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>
                  : <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                    {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>)}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell className="vert" rowSpan={5} style={{ padding: '0' }}>
                <Tooltip data-html={true} title={<>{infosClim?.map((i,index) => <h3 key={(index+1)+i.type!+i.detail}>{"#"+(index+1)+": "+i.type+" / "+i.detail+" / "+i.rq}</h3>)}</>}>
                  <InfoIcon style={{right: '0.1rem', bottom: '0.3rem', position: 'relative', 
                    color: infosClim.length > 0 ? 'primary' : 'transparent' }} /> 
                </Tooltip>
                <Typography
                  color="secondary"
                >Climatisation
                </Typography>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Type
              </TableCell>
              <TableCell colSpan={2}>
                <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.clim_type0} name="clim_type0">
                  {climFields?.type.map((d) => ( infosClim[0].type !== d ?
                    <MenuItem key={d+"_0"} value={d}>{d}</MenuItem>
                    : <MenuItem key={d+"_0"} value={d} selected><em>{d}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              <TableCell colSpan={2}>
              <Select margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.clim_type1} name="clim_type1">
                  {climFields?.type.map((d) => ( infosClim[1].type !== d ?
                    <MenuItem key={d+"_1"} value={d}>{d}</MenuItem>
                    : <MenuItem key={d+"_1"} value={d} selected><em>{d}</em></MenuItem>
                  ))}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Détails
              </TableCell>
              <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
                <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.clim_detail0?.map((k) => k) || []} name="clim_detail0">
                  {climFields?.detail.map((d) => <MenuItem key={d+"_0"} value={d}>{d}</MenuItem>
                    /*( infosClim[0].detail?.some(item => d === item) ?
                    <MenuItem key={d+"_0"} value={d}>{d}</MenuItem>
                    : <MenuItem key={d+"_0"} value={d} selected><em>{d}</em></MenuItem>
                  )*/)}
                </Select>
              </TableCell>
              <TableCell colSpan={2} style={{ maxWidth: '18rem' }}>
                <Select multiple margin="dense" variant="outlined" onChange={hdlSetChauff}
                  className={classes2.demiWidth} value={state.clim_detail1?.map((k) => k) || []} name="clim_detail1">
                  {climFields?.detail.map((d) => <MenuItem key={d+"_1"} value={d}>{d}</MenuItem>
                    /*( infosClim[0].detail?.some(item => d === item) ?
                    <MenuItem key={d+"_1"} value={d}>{d}</MenuItem>
                    : <MenuItem key={d+"_1"} value={d} selected><em>{d}</em></MenuItem>
                  )*/)}
                </Select>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={1}>
                Remarque
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="clim_rq0"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              <TableCell colSpan={2}>
                <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="clim_rq1"
                  type="text"
                  variant="outlined"
                  //onChange={handleChange}
                  error={'reponses' in errors}
                />
              </TableCell>
              </TableRow>
              <TableRow className={classes2.lastTrSiteDetails}>
              <TableCell>Appareils liés</TableCell>
              <TableCell colSpan={3} style={{ maxWidth: '18rem' }}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined" style={{maxWidth: '22rem', minWidth: '28rem' }}
                  onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="clim_id"
                  value={state.clim_id || []}>
                  { equipements.filter((e) => e.poste.name === "CVC").map((eq) => 
                  eq.voies2mesures.length > 0 ?
                    <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;<b>{eq.voies2mesures[0]?.id_conc+"/"
                      +eq.voies2mesures[0]?.id_module+"-v"+eq.voies2mesures[0]?.number+" "}</b>&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                      {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>
                  : <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+" : "}&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                      {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>)}
                </Select>
              </TableCell>
              </TableRow>
            </TableBody>
          </Table>
            <Typography
                //variant={isMobile ? 'h7' : 'h6'}
                variant={/*isMobile ? 'h7' : */'h6'}
                color="secondary"
                style={{ marginRight: '0.2em', marginTop: '1em' }}
              >Piscine&nbsp;
              <Tooltip data-html={true} title={<><h3>{"Présence: "+infosPiscine.present}</h3>
                <h3>{"Type: "+infosPiscine.type}</h3>
                <h3>{"Chauffée: "+infosPiscine.chauffage}</h3>
                <h3>{"Long/Diam: "+infosPiscine.longueurOrDiam}</h3>
                <h3>{"Prof.: "+infosPiscine.prof}</h3>
                <h3>{"Conso pompe: "+infosPiscine.consoPompe}</h3>
                </>}>
                  <InfoIcon style={{top: '0.1rem', position: 'relative', 
                    color: infosChauff.length > 0 ? 'primary' : 'transparent' }} /> 
              </Tooltip>
            </Typography>
            <Table>
            <TableBody>
              <TableRow>
                <TableCell>
                  <InputLabel shrink>Présence</InputLabel>
                  <Select inputRef={register} margin="dense" variant="outlined" label="Présence" name="piscine_infos_present"
                    value={state.piscine_infos_present} onChange={hdlSetChauff} >
                    {piscineFields.present.map((f) => (
                      infosPiscine.present === f ? <MenuItem key={"presencePiscine_"+f} value={f} {...infosPiscine.present === "Oui" ? 'selected' : null }>{f}</MenuItem>
                      : <MenuItem key={"presencePiscine_"+f} value={f}>{f}</MenuItem> ))}
                  </Select>
                </TableCell>
                { state.piscine_infos_present === "Oui" && <>
                <TableCell>
                  <InputLabel shrink>Type</InputLabel>
                  <Select inputRef={register} margin="dense" variant="outlined" /*onChange={handleChangePiscine}*/ name="piscine_infos_type"
                    value={state.piscine_infos_type} onChange={hdlSetChauff} >
                    {piscineFields.type.map((f) => (
                      infosPiscine.type === f ? <MenuItem key={"typePiscine_"+f} value={f} selected>{f}</MenuItem>
                      : <MenuItem key={"typePiscine_"+f} value={f}>{f}</MenuItem> ))}
                  </Select>
                </TableCell>
                <TableCell>
                  <InputLabel shrink>Chauffée</InputLabel>
                  <Select inputRef={register} margin="dense" variant="outlined" label="Présence" /*onChange={handleChangePiscine}*/ name="piscine_infos_chauffage"
                    value={state.piscine_infos_chauffage} onChange={hdlSetChauff} >
                    {piscineFields.chauffage.map((f) => (
                      infosPiscine.chauffage === f ? <MenuItem key={"chauffagePiscine_"+f} value={f} selected>{f}</MenuItem>
                      : <MenuItem key={"chauffagePiscine_"+f} value={f}>{f}</MenuItem> ))}
                  </Select>
                </TableCell>
                <TableCell>
                  <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="piscine_infos_lgdia"
                  type="text"
                  label="Long/Diam (m)"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  />
                </TableCell>
                <TableCell>
                  <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="piscine_infos_larg"
                  type="text"
                  label="Largeur (m)"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  />
                </TableCell>
                <TableCell>
                  <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="piscine_infos_prof"
                  type="text"
                  label="Prof. (m)"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  />
                </TableCell>
                <TableCell>
                  <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="piscine_infos_consoppe"
                  type="text"
                  label="Conso Pompe (W)"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  />
                </TableCell>
                </>}
                </TableRow>
                <TableRow>
                <TableCell colSpan={7}>
                  <TextField margin='dense'
                  //className={MoreClasses?.tiersWidth}
                  inputRef={register}
                  name="piscine_infos_note"
                  type="text"
                  multiline
                  fullWidth
                  rows={3}
                  label="Notes sur la piscine"
                  variant="outlined"
                  style={{ marginTop: '1.1em' }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
              <TableCell colSpan={2}>Appareils/pompes</TableCell>
              <TableCell colSpan={6} style={{ maxWidth: '18rem' }}>
                <Select  /*displayEmpty defaultValue={currSite_id}*/ multiple 
                  /*id="chauff_detail1"*/ margin="dense" variant="outlined"
                  onChange={hdlSetChauff} className={classes2.demiWidth} /*defaultValue={infosChauff[0].detail}*/ name="piscine_id"
                  value={state.piscine_id || []}>
                  { equipements.filter((e) => e.usage.name.includes("ompe")).map((eq) => 
                    <MenuItem key={eq.id} value={eq.id}>{eq.usage.name+": "}&nbsp;&nbsp;<b>{eq.voies2mesures[0]?.id_conc+"/"
                      +eq.voies2mesures[0]?.id_module+"-v"+eq.voies2mesures[0]?.number+" "}</b>&nbsp;&nbsp;(<i>{eq.reponses}</i>&nbsp;&nbsp;)
                      {" ["+String(eq.app_date_start).split('T')[0]+(eq.app_date_end ? "/ Ended: "+String(eq.app_date_end).split('T')[0] : '')+"] [ID:"+eq.id+"]"}</MenuItem>)}
                </Select>
              </TableCell>
              </TableRow>
            </TableBody>
            </Table></>) : null }
          { currentData?.veilles_app !== undefined && selectedScenario !== "" && currentData?.veilles_app?.length > 1 ?
            <><Typography  className={classes2.TopDivider}
                //variant={isMobile ? 'h7' : 'h6'}
                variant={/*isMobile ? 'h7' : */'h6'}
                color="secondary"
                style={{ marginRight: '0.2em', paddingTop: '1.5rem', marginTop: '1.5rem' }}
              >Informations de veilles appareils
            </Typography>
            <p>Ces informations sont là en tant que traces : elles sont normalement destinées à être reportées dans les détails des équipements du logements.</p>
            <Table>
            <TableBody>
              {currentData?.veilles_app?.map((app,index) =>
                <TableRow key={app+"_"+index}><TableCell>{app}</TableCell><TableCell>{currentData?.veilles_pw?.[index]}</TableCell><TableCell>{currentData?.veilles_rq?.[index]}</TableCell></TableRow>)}
            </TableBody>
            </Table></> : null }
      </form>
      </div>
      );
    }
    return (<>
      {isEditMode && <LogementForm/>}
      {<ContactForm/>}
    </>);
  };

  export default SiteDetailFormx;
